module.exports = __webpack_public_path__ + "img/acc_a.e70f400f.png";